import React, { useState } from 'react';
import { ContentURL, getContentUrl } from '../../../Utils/ContentURL';
import './CopyLinkSection.scss';

interface CopyLinkSectionProps {
    shareUrl: string;
}

export const CopyLinkSection: React.FC<CopyLinkSectionProps> = ({ shareUrl }) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyLinkToClipboard = async () => {
        try {
            // Try modern Clipboard API first
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(shareUrl);
                setIsCopied(true);
            } else {
                // Fallback to older method for browsers that don't support Clipboard API
                const dummyElement = document.createElement("input");
                document.body.appendChild(dummyElement);
                dummyElement.value = shareUrl;
                dummyElement.select();
                dummyElement.setSelectionRange(0, 99999); // For mobile devices
                document.execCommand("copy");
                document.body.removeChild(dummyElement);
                setIsCopied(true);
            }
        } catch (error) {
            console.error('Failed to copy link:', error);
            // Try fallback method if Clipboard API fails
            try {
                const dummyElement = document.createElement("input");
                document.body.appendChild(dummyElement);
                dummyElement.value = shareUrl;
                dummyElement.select();
                dummyElement.setSelectionRange(0, 99999);
                document.execCommand("copy");
                document.body.removeChild(dummyElement);
                setIsCopied(true);
            } catch (fallbackError) {
                console.error('Fallback copy also failed:', fallbackError);
            }
        }
    };

    return (
        <div className="copy-link-section">
            <p className="send-via-link-title">Copy link to share via message or email</p>
            <div className="share-via-link-section">
                <div className="link-container">
                    <p className="share-link">{shareUrl}</p>
                </div>
                <button className="copy-btn" onClick={copyLinkToClipboard}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 8.33328C17.5 7.87305 17.1269 7.49995 16.6666 7.49995H8.33331C7.87308 7.49995 7.49998 7.87305 7.49998 8.33328V16.6666C7.49998 17.1269 7.87308 17.5 8.33331 17.5H16.6666C17.1269 17.5 17.5 17.1269 17.5 16.6666V8.33328ZM12.5 3.33328C12.5 2.87685 12.1231 2.49995 11.6666 2.49995H3.33331C2.87688 2.49995 2.49998 2.87685 2.49998 3.33328V11.6666C2.49998 12.123 2.87688 12.4999 3.33331 12.4999C3.79355 12.4999 4.16665 12.873 4.16665 13.3333C4.16665 13.7935 3.79355 14.1666 3.33331 14.1666C1.95641 14.1666 0.833313 13.0435 0.833313 11.6666V3.33328C0.833313 1.95638 1.95641 0.833282 3.33331 0.833282H11.6666C13.0436 0.833282 14.1666 1.95638 14.1666 3.33328C14.1666 3.79352 13.7936 4.16662 13.3333 4.16662C12.8731 4.16662 12.5 3.79352 12.5 3.33328ZM19.1666 16.6666C19.1666 18.0473 18.0474 19.1666 16.6666 19.1666H8.33331C6.9526 19.1666 5.83331 18.0473 5.83331 16.6666V8.33328C5.83331 6.95257 6.9526 5.83328 8.33331 5.83328H16.6666C18.0474 5.83328 19.1666 6.95257 19.1666 8.33328V16.6666Z" fill="#1A1A1A" />
                    </svg>
                    Copy
                </button>
            </div>

            {isCopied && (
                <div className="success-banner">
                    <img src={getContentUrl(ContentURL.images.GreenCheckMark)} alt="Success" />
                    <span>Link copied to clipboard</span>
                </div>
            )}
        </div>
    );
};
